export const draggableDataName = 'data-vue-dnd-kit-draggable';
export const droppableDataName = 'data-vue-dnd-kit-droppable';

export const VUE_DND_KIT_OPTIONS = Symbol('vue-dnd-kit-options');
